export default {
	required: v => !!v || 'Requis',
	min: v => !!v && v.length >= 6 || 'Min 6 caractères',
	email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "l'e-mail doit être valide"
}